export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div>
            <span className="font-heading text-2xl text-primary-400">妖精视频</span>
            <p className="text-sm text-foreground-400 mt-3 leading-relaxed">
              水果植物系列影视聚合平台，汇集香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台内容，高清免费在线观看，电视剧全集不缓冲。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium text-sm text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门话题</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热度榜单</a></li>
              <li><a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">内容索引</a></li>
              <li><a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新动态</a></li>
            </ul>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="font-medium text-sm text-background-50 mb-4">合作平台</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-400 whitespace-nowrap">香蕉视频</span></li>
              <li><span className="text-sm text-foreground-400 whitespace-nowrap">蜜桃视频</span></li>
              <li><span className="text-sm text-foreground-400 whitespace-nowrap">西瓜视频</span></li>
              <li><span className="text-sm text-foreground-400 whitespace-nowrap">樱花视频</span></li>
              <li><span className="text-sm text-foreground-400 whitespace-nowrap">糖豆视频 · 樱桃视频 · 蘑菇视频</span></li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-medium text-sm text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              妖精视频与多家优质影视内容平台保持长期友好合作关系，持续为观众提供丰富多样的观影选择。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 妖精视频 yaqingvideo.com. 本站为内容聚合导航平台，视频内容版权归各合作平台所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">返回顶部</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">常见问答</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}